import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios.js'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import mixin from './mixin.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import './style/all.scss'
import ImgInputer from 'vue-img-inputer'
import 'vue-img-inputer/dist/index.css'
// fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faRightFromBracket, faCartPlus, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './registerServiceWorker'
import VueGtag from 'vue-gtag'

// Google Analytics
Vue.use(VueGtag, {
  config: { id: 'G-ZT5V4NYKCR' }
})

library.add(faRightFromBracket, faCartPlus, faArrowUp)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueSweetalert2)
Vue.mixin(mixin)
Vue.use(VueAwesomeSwiper)
Vue.component('ImgInputer', ImgInputer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
